<template><div><!-- <component-combinator component-name="DtTable" /> -->
<h2 id="variants-and-examples" tabindex="-1" class="d-docsite--header-2">Variants and Examples <a class="header-anchor d-link d-docsite--link d-link" href="#variants-and-examples" aria-hidden="true">#</a></h2>
<h3 id="base-style" tabindex="-1" class="d-docsite--header-3">Base Style <a class="header-anchor d-link d-docsite--link d-link" href="#base-style" aria-hidden="true">#</a></h3>
<code-example bgclass="d-bgc-primary" class="d-d-block" source-code='&lt;table class=&quot;d-table dialtone-doc-table&quot;&gt;
  &lt;caption class=&quot;d-table__caption&quot;&gt;Office List&lt;/caption&gt;
  &lt;thead&gt;
    &lt;tr&gt;
      &lt;th scope=&quot;col&quot;&gt;Office&lt;/th&gt;
      &lt;th scope=&quot;col&quot;&gt;Country&lt;/th&gt;
      &lt;th scope=&quot;col&quot; width=&quot;10%&quot;&gt;Employees&lt;/th&gt;
      &lt;th scope=&quot;col&quot;&gt;Contact&lt;/th&gt;
    &lt;/tr&gt;
  &lt;/thead&gt;
  &lt;tbody&gt;
    &lt;tr v-for=&quot;i in examples&quot;&gt;
      &lt;th scope=&quot;row&quot;&gt;{{ i.office }}&lt;/th&gt;
      &lt;td&gt;{{ i.country }}&lt;/td&gt;
      &lt;td&gt;{{ i.size }}&lt;/td&gt;
      &lt;td&gt;{{ i.contact }}&lt;/td&gt;
    &lt;/tr&gt;
  &lt;/tbody&gt;
&lt;/table&gt;'>
<table class="d-table dialtone-doc-table">
  <caption class="d-table__caption">Office List</caption>
  <thead>
    <tr>
      <th scope="col">Office</th>
      <th scope="col">Country</th>
      <th scope="col" width="10%">Employees</th>
      <th scope="col">Contact</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="i in examples">
      <th scope="row">{{ i.office }}</th>
      <td>{{ i.country }}</td>
      <td>{{ i.size }}</td>
      <td>{{ i.contact }}</td>
    </tr>
  </tbody>
</table>
</code-example>
<h3 id="inverted-style" tabindex="-1" class="d-docsite--header-3">Inverted Style <a class="header-anchor d-link d-docsite--link d-link" href="#inverted-style" aria-hidden="true">#</a></h3>
<dt-notice kind="warning" title="Deprecated" :show-close="false" class="d-wmx100p d-my-200 dialtone-doc-notice">
The <code v-pre>d-table--inverted</code> modifier has been deprecated. Use the <RouteLink to="/components/mode-island.html#inverting" class="d-docsite--link d-link">v-dt-mode directive</RouteLink> instead.
</dt-notice>
<h3 id="striped" tabindex="-1" class="d-docsite--header-3">Striped <a class="header-anchor d-link d-docsite--link d-link" href="#striped" aria-hidden="true">#</a></h3>
<code-example bgclass="d-bgc-primary" class="d-d-block" source-code='&lt;table class=&quot;d-table dialtone-doc-table d-table--striped&quot;&gt;
  &lt;caption class=&quot;d-table__caption&quot;&gt;Office List&lt;/caption&gt;
  &lt;thead&gt;
    &lt;tr&gt;
      &lt;th scope=&quot;col&quot;&gt;Office&lt;/th&gt;
      &lt;th scope=&quot;col&quot;&gt;Country&lt;/th&gt;
      &lt;th scope=&quot;col&quot; width=&quot;10%&quot;&gt;Employees&lt;/th&gt;
      &lt;th scope=&quot;col&quot;&gt;Contact&lt;/th&gt;
    &lt;/tr&gt;
  &lt;/thead&gt;
  &lt;tbody&gt;
    &lt;tr v-for=&quot;i in examples&quot;&gt;
      &lt;th scope=&quot;row&quot;&gt;{{ i.office }}&lt;/th&gt;
      &lt;td&gt;{{ i.country }}&lt;/td&gt;
      &lt;td&gt;{{ i.size }}&lt;/td&gt;
      &lt;td&gt;{{ i.contact }}&lt;/td&gt;
    &lt;/tr&gt;
  &lt;/tbody&gt;
&lt;/table&gt;'>
<table class="d-table dialtone-doc-table d-table--striped">
  <caption class="d-table__caption">Office List</caption>
  <thead>
    <tr>
      <th scope="col">Office</th>
      <th scope="col">Country</th>
      <th scope="col" width="10%">Employees</th>
      <th scope="col">Contact</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="i in examples">
      <th scope="row">{{ i.office }}</th>
      <td>{{ i.country }}</td>
      <td>{{ i.size }}</td>
      <td>{{ i.contact }}</td>
    </tr>
  </tbody>
</table>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<component-class-table component-name="table" /><h2 id="accessibility" tabindex="-1" class="d-docsite--header-2">Accessibility <a class="header-anchor d-link d-docsite--link d-link" href="#accessibility" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use the <code v-pre>caption</code> element to describe a table in the same way you would use a heading. A caption helps users find, navigate and understand tables.</p>
<p class="d-docsite--paragraph">We provide <code v-pre>.d-table__caption</code> for a basic caption style, but you can also use utility classes to apply custom styles as needed.</p>
</div></template>


<script setup>
  import { examples } from '@data/table.json';
</script>